import PropTypes from 'prop-types'

export const contactProps = PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    company: PropTypes.shape({
        name: PropTypes.string
    }),
    associationGroup: PropTypes.shape({
        name: PropTypes.string
    }),
    image: PropTypes.shape({ url: PropTypes.string }),
    phoneNumbers: PropTypes.arrayOf(PropTypes.string),
    faxNumbers: PropTypes.arrayOf(PropTypes.string),
    mobileNumbers: PropTypes.arrayOf(PropTypes.string),
    emails: PropTypes.arrayOf(PropTypes.string)
})
